import type { PutApiV1ThreeLetterCodePartnerAdminsTopBannersIdBody } from '@fukuri-admins/apis/client/gen/model';

type TopBannerForReOrder = {
  /** タイトル */
  title: string;
  /** 遷移先URL */
  transitionUrl: string;
  /** アクティブ状態（true: 表示中, false: 非表示） */
  isActive: boolean;
};

type GenerateReOrderRequestArgs = {
  /** 更新対象のトップバナーデータ */
  topBanner: TopBannerForReOrder;
  /** 新しい並び順（1から始まる） */
  newSortOrder: number;
};

type IGenerateReOrderRequest = (
  args: GenerateReOrderRequestArgs
) => PutApiV1ThreeLetterCodePartnerAdminsTopBannersIdBody;

/**
 * 並び替え用のAPIリクエストボディを生成する
 *
 * @param topBanner - 更新対象のトップバナーデータ
 * @param newSortOrder - 新しい並び順（1から始まる）
 * @returns PUTリクエストボディ（sort_orderを更新した状態）
 */
export const generateReOrderRequest: IGenerateReOrderRequest = ({ topBanner, newSortOrder }) => ({
  top_banner: {
    title: topBanner.title,
    transition_url: topBanner.transitionUrl,
    status: topBanner.isActive ? 0 : 1, // 0: active(表示), 1: inactive(非表示)
    sort_order: newSortOrder,
    image: undefined, // 既存画像を維持
  },
});
